import { __read, __spread } from "tslib";
import { formatValue as valueFormatter } from '@keen.io/charts-utils';
import { extractGroupBySettings } from '@keen.io/query';
import { KEEN_TABLE_INTERVAL } from '@keen.io/parser';
export var transform = function (_a) {
    var query = _a.query, chartSettings = _a.chartSettings;
    var data = chartSettings.data;
    var propertyNames = query.property_names, groupBy = query.group_by, interval = query.interval;
    var columnsOrder = [];
    var columnsRename = chartSettings.columnsNamesMapping
        ? chartSettings.columnsNamesMapping
        : null;
    var columnsFormatters = chartSettings.formatValue
        ? chartSettings.formatValue
        : {};
    if (propertyNames) {
        columnsOrder = propertyNames;
    }
    else if (groupBy && !interval) {
        columnsOrder = extractGroupBySettings(groupBy);
    }
    else if (interval) {
        columnsOrder = [KEEN_TABLE_INTERVAL];
    }
    var _b = __read(data, 1), firstRecord = _b[0];
    var columns = Object.keys(firstRecord).sort(function (a, b) {
        if (!columnsOrder.includes(a))
            return 0;
        return columnsOrder.indexOf(a) - columnsOrder.indexOf(b);
    });
    var renamedColumns = columnsRename
        ? columns.map(function (columnName) {
            return columnsRename[columnName] ? columnsRename[columnName] : columnName;
        })
        : columns;
    return __spread([
        renamedColumns
    ], data.map(function (item) {
        return columns.map(function (columnName) {
            return columnsFormatters[columnName]
                ? valueFormatter(item[columnName], columnsFormatters[columnName])
                : item[columnName];
        });
    }));
};
